import React from 'react';
import { Modal } from 'antd';
import { Form, Field } from 'react-final-form';
import { required } from '../validations';
import {
    RenderAntInputTextField,
} from '../render-form-fields/RenderFormFields';
import { onInputNumberMaxLenCheck } from '../update-monthly-compensation-modal/UpdateMonthlyCompensationModal';
import { MONTHLY_HOURS_OF_WORK, formatValueAsCurrency } from '../../../services/util/currency';

export function UpdateRateModal({
    newDesiredSalaryHourly,
    devNteHourlyRate,
    rateType,
    devCurrencyRate,
    devCurrency,
    temporaryRateData,
    onClose = () => null,
    onOK = () => null,
}) {
    const isHourly = rateType === "HOURLY";

    const close = () => {
        onClose();
    };

    const onSubmit = (values) => {
        if (newDesiredSalaryHourly && isHourly ? values.newRate === newDesiredSalaryHourly : values.newRate === newDesiredSalaryHourly * MONTHLY_HOURS_OF_WORK) {
            close();
            return;
        }
        if (devNteHourlyRate && isHourly ? values.newRate === devNteHourlyRate : values.newRate === devNteHourlyRate * MONTHLY_HOURS_OF_WORK) {
            close();
            return;
        }
        const rate = Number(values.newRate);
        onOK({
            newDesiredSalaryHourly: isHourly ? rate : rate / MONTHLY_HOURS_OF_WORK,
            newDesiredSalaryMonthly: isHourly ? rate * MONTHLY_HOURS_OF_WORK : rate,
        });
        close();
    };

    const initialValues = temporaryRateData ? {
        newRate: isHourly ? temporaryRateData.newDesiredSalaryHourly : temporaryRateData.newDesiredSalaryMonthly,
    } : {
        newRate: isHourly ? newDesiredSalaryHourly ? newDesiredSalaryHourly : devNteHourlyRate : (newDesiredSalaryHourly ?  newDesiredSalaryHourly : devNteHourlyRate) * MONTHLY_HOURS_OF_WORK,
    };

    return (
        <Form
            initialValues={initialValues}
            onSubmit={onSubmit}
            render={({ handleSubmit, hasValidationErrors, values }) => {
                return (
                    <Modal
                        className="update-monthly-compensation-modal"
                        closable={false}
                        centered
                        visible={true}
                        open
                        width={650}
                        okText="Confirm"
                        okButtonProps={{
                            disabled: hasValidationErrors,
                            'data-cy': 'update-monthly-compensation-modal__button-ok',
                        }}
                        onCancel={close}
                        onOk={handleSubmit}
                    >
                        <div className="update-monthly-compensation-modal__container">
                            <div className="update-monthly-compensation-modal__header">
                                <div className="update-monthly-compensation-modal__header__maintext">
                                    Confirm Rate
                                </div>
                            </div>
                            <div className="update-monthly-compensation-modal__body">
                                <span className="update-monthly-compensation-modal__header__subtext">
                                    Enter your new rate in USD
                                </span>
                                <Field
                                    className="gutter-bottom-sm"
                                    name="newRate"
                                    validate={required}
                                >
                                    {({ input, meta }) => (
                                        <RenderAntInputTextField
                                            type="number"
                                            addonAfter={isHourly ? "/ hr" : "/ month"}
                                            input={input}
                                            meta={meta}
                                            onInput={(e) => onInputNumberMaxLenCheck(e.target, 9)}
                                        />
                                    )}
                                </Field>
                                {(devCurrency && devCurrency !== "USD") ? <span className="update-monthly-compensation-modal__info">
                                    {`Equals to ${formatValueAsCurrency(values.newRate * devCurrencyRate, devCurrency)} ${devCurrency} / ${isHourly ? "hr" : "month"} approximately`}
                                </span> : null}
                            </div>
                        </div>
                    </Modal>
                );
            }}
        />
    );
}
